/*
 * FeatureUnavailableNotice — what a panel renders on an appliance whose build
 * predates it.
 *
 * Tone is the whole design here. This is not an error: nothing is broken, the
 * operator did nothing wrong, and the fix is a scheduled update rather than
 * anything they can do on this screen. So it reads as information, in the
 * dashboard's own colours, and it names the box and the version-shaped reason
 * rather than showing a stack of red.
 *
 * ! file components/FeatureUnavailableNotice.js
 * ---------------
 * \author: Tolga O. Atalay
 * \Affiliation: A2 Labs LLC / A12XT Inc.
 * \date: 2026
 */

import React from "react";
import { FiClock, FiInfo } from "react-icons/fi";

export default function FeatureUnavailableNotice({
  nodeId,
  feature = "This feature",
  detail,
  compact = false,
}) {
  const body = (
    <>
      <strong>{feature} is not available on {nodeId || "this box"} yet.</strong>{" "}
      {detail ||
        "This appliance is running a build from before the feature shipped. It will appear " +
          "here on its own once the box is updated — nothing to do on this screen, and " +
          "nothing else on the appliance is affected."}
    </>
  );

  if (compact) {
    return (
      <div className="feat-na feat-na--compact">
        <FiClock size={14} />
        <span>{body}</span>
      </div>
    );
  }

  return (
    <div className="feat-na">
      <span className="feat-na-ico"><FiInfo size={18} /></span>
      <div className="feat-na-body">
        {body}
        <div className="feat-na-hint">
          Other panels for this edge are unaffected, and edges already running the
          newer build show it now.
        </div>
      </div>
    </div>
  );
}
